export default __webpack_public_path__ + "static/tecalis-students_05-678aade4f22f83ce9c95efd64bc779b7.png";